import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// Main BBC Android app exposes window.AndroidBridge; background location sharing lives there (no Navigation APK needed).
export const nativeNav = () => (window.AndroidBridge && typeof window.AndroidBridge.startNavigation === 'function' ? window.AndroidBridge : null);
export const isNavLocked = (circles, myId) => (circles || []).some((c) => c.lock_sharing && c.owner_id !== myId);

export function readNavStatus() {
  const b = nativeNav(); if (!b) return null;
  try { return JSON.parse(b.navigationStatus()); } catch { return null; }
}

// Runs once per session: if this phone runs the BBC app and the user belongs to a circle, hand over the token.
export default function NativeNavigationBridge() {
  const { token, user } = useAuth();
  useEffect(() => {
    const b = nativeNav(); if (!b || !token || !user) return;
    fetch(`${API}/api/navigation/circles`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : []))
      .then((circles) => {
        if (!Array.isArray(circles) || !circles.length) return;
        const locked = isNavLocked(circles, user.user_id);
        const st = readNavStatus();
        if (locked || (st && st.enabled)) b.startNavigation(token, locked);
        else if (st && !st.enabled && !localStorage.getItem('nav_bg_declined')) b.startNavigation(token, false);
      }).catch(() => {});
  }, [token, user]);
  return null;
}

// Status + controls for the Navigation page card.
export function useNativeNavigation(circles, myId) {
  const { token } = useAuth();
  const [status, setStatus] = useState(() => readNavStatus());
  const locked = isNavLocked(circles, myId);
  const refresh = useCallback(() => setStatus(readNavStatus()), []);
  useEffect(() => {
    const b = nativeNav(); if (!b || !token || !circles || !circles.length) return;
    b.updateNavigation(token, locked); refresh();
  }, [token, locked, circles, refresh]);
  useEffect(() => { const id = setInterval(refresh, 3000); return () => clearInterval(id); }, [refresh]);
  const turnOn = () => { localStorage.removeItem('nav_bg_declined'); nativeNav().startNavigation(token, locked); setTimeout(refresh, 800); };
  const turnOff = () => { if (nativeNav().stopNavigation()) localStorage.setItem('nav_bg_declined', '1'); setTimeout(refresh, 300); };
  return { available: !!nativeNav(), status, locked, turnOn, turnOff };
}
